import patchPdfviewerBase from "./patchPdfviewerBase";
import patchToolbar from "./patchToolbar";

export default function (pdfViewer) {
	patchPdfviewerBase(pdfViewer.viewerBase);
	patchToolbar(pdfViewer.toolbarModule);
}